// src/App.jsx
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminRoutes from "./routes/AdminRoutes";
import LandlordRoutes from "./routes/LandlordRoutes";
import { logTokenExpiry } from "./utils/tokenDebug";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Landlord routes at root */}
        <Route path="/*" element={<LandlordRoutes />} />

        {/* Admin routes */}
        <Route path="/admin/*" element={<AdminRoutes />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
